import { FunctionComponent } from "react";
import { Box, SvgIcon, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import Tooltip, { TooltipProps, tooltipClasses } from "@mui/material/Tooltip";
import Icon from "@mdi/react";
import { IProps } from "./IProps";

const LightTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: "#1BA0E9",
    fontWeight: 600,
    maxWidth: 240,
    borderRadius: 8,
    textTransform: "none",
    fontSize: theme.typography.pxToRem(11),
    padding: "6px 12px",
  },
}));

export const BackgroundIcon: FunctionComponent<IProps> = (
  props
): JSX.Element => {
  return (
    <LightTooltip
      title={<Typography fontSize={11}>{props.label}</Typography>}
      placement="top-start"
    >
      <Box
        onClick={props.onClick}
        sx={{
          width: props.width ?? 30,
          height: props.height ?? 30,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: "50%",
          backgroundColor: props.bgColor,
          cursor: props.onClick ? "pointer" : "default",
        }}
      >
        <SvgIcon
          sx={{
            color: props.color,
            width: props.iconWidth ?? 18,
            height: props.iconHeight ?? 18,
          }}
        >
          <Icon path={props.icon} />
        </SvgIcon>
      </Box>
    </LightTooltip>
  );
};
